<template>
  <div v-if="loaded" class="result">
    <div class="screen-only">
      <v-alert :value="true" color="info" icon="info" outline>A4縦向きで印刷してください。</v-alert>

      <v-btn @click="print">印刷</v-btn>
    </div>

    <section class="sheet">
      <title-and-name class title="チャレンジシート" :name="sheet.name"/>
      <table>
        <colgroup>
          <col style="width:30mm;">
          <col style="width:170mm;">
        </colgroup>
        <tr style="height: 10mm;">
          <th>スローガン</th>
          <td class="slogan body">{{sheet.slogan}}</td>
        </tr>
      </table>
      <div class="plan" v-for="(plan, i) in sheet.plans" :key="i">
        <table>
          <colgroup>
            <col style="width:30mm;">
            <col style="width:15mm;">
            <col style="width:30mm;">
            <col style="width:125mm;">
          </colgroup>
          <tr style="height: 10mm;">
            <th>改革プラン {{i+1}}</th>
            <td colspan="3" class="plan body">{{plan.plan}}</td>
          </tr>
          <tr style="height: 10mm;">
            <th>具体的な施作</th>
            <td colspan="3">{{plan.method}}</td>
          </tr>
          <tr style="height: 10mm;">
            <th>承認コメント</th>
            <td colspan="3">{{plan.approve_comment}}</td>
          </tr>
          <tr style="height: 10mm;">
            <th>本人評価</th>
            <td>{{plan.self_point}}</td>
            <th>コメント</th>
            <td>{{plan.self_comment}}</td>
          </tr>
          <tr style="height: 10mm;">
            <th>上司評価</th>
            <td>{{plan.rater_point}}</td>
            <th>コメント</th>
            <td>{{plan.reater_comment}}</td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>


<script>
import db from "@/components/firebaseInit";
import Plan from "@/components/targets/plan.vue";
import TitleAndName from "@/components/print_target/title_and_name.vue";
import { mapActions, mapGetters } from "vuex";
import { unixtimeToFormattedDate } from "@/utils/datetime.js";

export default {
  components: {
    TitleAndName
  },
  props: [],
  data() {
    return {
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets"),
      dbRefTargets: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("targets"),
      sheet: null,
      target: null,
      dialog: false,
      permissionDic: { rating: "rap9BWtsnF", approving: "apWd2mrSq4" },
      invertedPermissionDic: { rap9BWtsnF: "rating", apWd2mrSq4: "approving" }
    };
  },
  computed: {
    loaded() {
      return this.sheet && this.target;
    }
  },
  mounted() {
    this.reloadItems();
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true);
      try {
        const sheet = await this.dbRef.doc(this.$route.params.sheet_id).get();
        if (!sheet.exists) {
          throw { code: "target/sheet-not-found" };
        }
        this.sheet = { ...sheet.data(), id: sheet.id };

        const target = await this.dbRefTargets.doc(this.sheet.target_id).get();
        this.target = { ...target.data(), id: target.id };

        this.changeLoadingState(false);
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false);
      }
    },
    print() {
      window.print();
    },
    getPeriod(start, end) {
      return (
        unixtimeToFormattedDate(start) + " ~ " + unixtimeToFormattedDate(end)
      );
    },

    ...mapActions("app", ["changeLoadingState"])
  }
};
</script>


<style lang="scss" scoped>
@media screen {
  .screen-only {
    font-size: large;
  }
  .sheet {
    background: white; /* 背景を白く */
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3); /* ドロップシャドウ */
    margin: 5mm;
  }
  .result {
    overflow: scroll;
    white-space: nowrap;
  }
}
.plan {
  margin-top: 5mm;
}
.result-row {
  margin: 10px 0;
}

@page {
  size: A4;
  margin: 0;
}
@media print {
  .screen-only {
    display: none;
  }
  .result section:first-of-type {
    margin-top: -88px;
    // App.vue のv-content(<main>) に64px、 v-containerに24pxのpaddingがあるため、最初のセクションを88px上方向に調整
  }
  * {
    -webkit-transition: none !important;
    transition: none !important;
  }
}

.sheet {
  width: 210mm;
  height: 297mm;
  padding: 5mm;
  page-break-after: always;
  position: relative;
}

.slogan.body{

    font-size: 12pt;
}
.plan.body{

    font-size: 12pt;
}

.print-item {
  position: absolute;
}
#summary-table {
  width: 100%;
  position: absolute;
  top: 230mm;
}
h3 {
  margin-bottom: 5pt;
}
.categoryTitle {
  margin-top: 25px;
  margin-bottom: 10px;
}
img#logo {
  top: 200pt;
  left: 145pt;
}
#company-name {
  top: 350pt;
  font-size: 30pt;
  left: 445pt;
}
#info-table {
  top: 25pt;
  left: 15pt;
}

.result-table {
  left: 15pt;
}
$comment-box-width: 120mm;
.comment-box {
  width: $comment-box-width; /* ボックスの横幅を指定 */

  border: 1px solid rgba(0, 0, 0, 0.12); /* 境界線を実線で指定 */
  /* border-radius: 10px;	ボックスの四つ角を丸くする */
  text-align: left;
  padding: 5pt;
  p {
    margin-bottom: 3pt;
    word-wrap: break-word;
    white-space: normal;
    font-size: 10px;
  }
}
.other-comment {
  height: 200mm; /* ボックスの高さを指定 */
  top: 20mm;
}
.self-comment {
  height: 40mm; /* ボックスの高さを指定 */
  top: 225mm;
}

$comment-box-left: 20pt;
$comment-box-margin: 15pt;

.comment-1 {
  left: $comment-box-left;
}
.comment-2 {
  left: $comment-box-left + $comment-box-width + $comment-box-margin;
}
.comment-3 {
  left: $comment-box-left + ($comment-box-width + $comment-box-margin) * 2;
}
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  td {
    padding: 5pt;
  }
}
table#name {
  font-size: 16px;
  position: absolute;
  bottom: 0%;
}
</style>
